import { ErrorToastConfig } from "app/utils/ToastConstants";
import { SuccessToastConfig } from "app/utils/ToastConstants";
import { Button } from "primereact/button";
import { Panel } from "primereact/panel";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useOutletContext, useSearchParams } from "react-router-dom";
import {
  editPropertyDetails,
  getLoanDetails,
  getReminderDetails,
  insertLogs,
} from "../../../homepurchase.service";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { Loading } from "app/components";
import HOA from "./HOA";
import PropertyTaxes from "./PropertyTaxes";
import InsuranceTaxes from "./InsuranceTaxes";
import HomeWarranty from "./HomeWarranty";
import { getSessionUserInformation } from "app/utils/utility.service";
import MortgageSchedule from "./MortgageSchedule";
import { NumericFormat } from "react-number-format";
import { findDaysInMonth } from "app/utils/utility.service";

 // List of months
 const months = [
  { label: "January", value: 1 },
  { label: "February", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 },
];

const PropertyPayments = ({ handleInputChanges,handleInputChange, handleInputChangeRent, values, options,updateDate, firstPrincipal, secondPrincipalAmt }) => {
  const navigate = useNavigate();
  const { data, setData } = useOutletContext(); // Access Parent's state
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [HOADetails, setHOADetails] = useState([]);
  const [PropertyTaxDetails, setPropertyTaxDetails] = useState([]);
  const [InsuranceTaxDetails, setInsuranceTaxDetails] = useState([]);
  const [HomeWarrantyDetails, setHomeWarrantyDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isDataFetchedHOA, setIsDataFetchedHOA] = useState(false);
  const [isDataFetchedPropTax, setIsDataFetchedPropTax] = useState(false);
  const [isDataFetchedInsTax, setIsDataFetchedInsTax] = useState(false);
  const [totalInsurance, setTotalInsurance] = useState(0);
  const [totalHOA, setTotalHOA] = useState(0);
  const [totalPTax, setTotalPTax] = useState(0);
  const [totalHomeWarranty, setTotalHomeWarranty] = useState(0);
  const [isDataFetchedHomeWarranty, setIsDataFetchedHomeWarranty] =
    useState(false);
  const [searchParams] = useSearchParams();
  const sessionValues = getSessionUserInformation();
  const propertyId = searchParams.get("propertyId");
  const clientId = searchParams.get("clientid");
  const userId = clientId && clientId !== "null" ? clientId : sessionValues.id;
  const [HOAModal, setHOAModal] = useState(false);
  const [PropertyTaxModal, setPropertyTaxModal] = useState(false);
  const [InsuranceTaxModal, setInsuranceTaxModal] = useState(false);
  const [HomeWarrantyModal, setHomeWarrantyModal] = useState(false);
  const [MortgageModal, setMortgageModal] = useState(false);
  const [loan, setLoan] = useState(null);
  const toast = useRef();
  const [selectedMonth, setSelectedMonth] = useState();
  const [selectedDay, setSelectedDay] = useState(null);
  const [days, setDays] = useState([]);
  const minValue = 1;
  const maxValue = 99.99;

  const showSuccess = (message) => {
    toast.current.show(SuccessToastConfig(message));
  };
  const showError = (message) => {
    toast.current.show(ErrorToastConfig(message ? message : "Error"));
  };
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const amortizationYears = [
    { name: "15 Years", code: 15 },
    { name: "30 Years", code: 30 },
    { name: "40 Years", code: 40 },
  ];

  const renderFooter = () => {
    return (
      <div className="grid">
        <div
          className={`${
            isDesktopOrLaptop ? "col-8" : "col-12 text-align-center"
          }`}
        >
          <Button
            type="button"
            label="Cancel"
            className="p-button-raised p-button-lg-1 mr-4"
            onClick={() =>  navigate("/home-purchase/portfolio/realestate")}
          />
          <Button
            type="submit"
            label="Save"
            className={`p-button-raised p-button-warning p-button-lg-1  ${
              isDesktopOrLaptop ? "" : "ml-4"
            }`}
            onClick={handleSubmit}
          />
        </div>
      </div>
    );
  };

  const validateInput = () => {
    if (
      !values.addressOne ||
      !values.addressTwo ||
      !values.city ||
      !values.state ||
      !values.country ||
      !values.zipcode ||
      !values.yearBuilt ||
      !values.typeOfBuilding ||
      !values.description ||
      !values.occupancy ||
      !values.category ||
      !values.mortgage ||
      !values.rateOfInterest ||
      !values.amortization ||
      !values.mortgagePaymentDate
    ) {
      return false;
    }

    if (isNaN(values.zipcode)) {
      return false;
    }
    return true;
  };
  useEffect(() => {
    fetchHOADetails();
    fetchInsTaxDetails();
    fetchPropertyTaxDetails();
    fetchHomeWarrantyDetails();
    fetchLoanDetails();
    const daysArray = findDaysInMonth(new Date(values.mortgagePaymentDate).getMonth() + 1);
    //setSelectedDay(daysArray[0]); // Default to the first day
    setDays(daysArray);
    setSelectedMonth(values.mortgagePaymentDate?new Date(values.mortgagePaymentDate).getMonth() + 1 : null);
    setSelectedDay(values.mortgagePaymentDate?new Date(values.mortgagePaymentDate).getDate():null);
  }, []);
  const fetchHOADetails = async () => {
    let list = await getReminderDetails(userId, "HOA", propertyId);
    list.reverse();
    if (list) {
      setIsLoading(false);
      if (list) {
        list.map((li, index) => (li.srNo = index + 1));
        const totalTax = list.reduce((sum, item) => sum + (Number(item.amount) || 0), 0);
        setTotalHOA(totalTax);
      }
      setHOADetails(list);
    }
  };
  const fetchPropertyTaxDetails = async () => {
    let list = await getReminderDetails(userId, "Property Taxes", propertyId);
    list.reverse();
    if (list) {
      setIsLoading(false);
      if (list) {
        list.map((li, index) => (li.srNo = index + 1));
        const totalTax = list.reduce((sum, item) => sum + (Number(item.amount) || 0), 0);
        setTotalPTax(totalTax);
      }
      setPropertyTaxDetails(list);
    }
  };
  const fetchInsTaxDetails = async () => {
    let list = await getReminderDetails(userId, "Insurance Taxes", propertyId);
    list.reverse();
    if (list) {
      setIsLoading(false);
      if (list) {
        list.map((li, index) => (li.srNo = index + 1));
        const totalTax = list.reduce((sum, item) => sum + (Number(item.amount) || 0), 0);
        setTotalInsurance(totalTax);
      }
      setInsuranceTaxDetails(list);
    }
  };
  const fetchHomeWarrantyDetails = async () => {
    let list = await getReminderDetails(userId, "Home Warranty", propertyId);
    list.reverse();
    if (list) {
      setIsLoading(false);
      if (list) {
        list.map((li, index) => (li.srNo = index + 1));
        const totalTax = list.reduce((sum, item) => sum + (Number(item.amount) || 0), 0);
        setTotalHomeWarranty(totalTax);
      }
      setHomeWarrantyDetails(list);
    }
  };
  const fetchLoanDetails = async () => {
    const loan = await getLoanDetails(values.userId, values.id);
    if(loan)
    setLoan(loan);
  };
    // Update days based on the selected month
  const updateDays = (month) => {
    const daysArray = findDaysInMonth(month);
    setDays(daysArray);
    setSelectedDay(daysArray[0]);
    updateDate(month, daysArray[0]);
  };
   // Handle month selection and update days
   const handleMonthChange = (e) => {
    setSelectedMonth(e.value);
    updateDays(e.value);
  };

  const handleDayChange = (e) => {
    setSelectedDay(e.value);
    if (selectedMonth) updateDate(selectedMonth, e.value);
  };
  const handleEditHOAModal = async () => {
    if (!HOAModal) {
      const payload = {
        description: "HOA",
      };
      insertLogs(payload);
    }
    if (!isDataFetchedHOA) {
      fetchHOADetails();
      setIsDataFetchedHOA(true);
    }
    setHOAModal(!HOAModal);
  };
  const handleEditPropertyTaxModal = () => {
    if (!PropertyTaxModal) {
      const payload = {
        description: "Property Tax",
      };
      insertLogs(payload);
    }
    if (!isDataFetchedPropTax) {
      fetchPropertyTaxDetails();
      setIsDataFetchedPropTax(true);
    }
    setPropertyTaxModal(!PropertyTaxModal);
  };
  const handleEditInsuranceTaxModal = () => {
    if (!InsuranceTaxModal) {
      const payload = {
        description: "Insurance Tax",
      };
      insertLogs(payload);
    }
  //  if (!isDataFetchedInsTax) {
    //  fetchInsTaxDetails();
      //setIsDataFetchedInsTax(true);
    //}
    setInsuranceTaxModal(!InsuranceTaxModal);
  };
  const handleEditHomeWarrantyModal = () => {
    if (!HomeWarrantyModal) {
      const payload = {
        description: "Insurance Tax",
      };
      insertLogs(payload);
    }
    if (!isDataFetchedHomeWarranty) {
      fetchHomeWarrantyDetails();
      setIsDataFetchedHomeWarranty(true);
    }
    setHomeWarrantyModal(!HomeWarrantyModal);
  };
  const handleEditMortgagePaymentModal = async () => {
    if (!MortgageModal) {
      const payload = {
        description: "Mortgage",
      };
      insertLogs(payload);
    }
   
    setMortgageModal(!MortgageModal);
  };
  const renderEditHOAModal = () => (
    <HOA
      HOAModal={HOAModal}
      handleEditHOAModal={handleEditHOAModal}
      HOADetails={HOADetails}
      fetchHOADetails={fetchHOADetails}
      handleInputChanges={handleInputChanges}
    />
  );
  const renderEditPropertyTaxesModal = () => (
    <PropertyTaxes
      PropertyTaxModal={PropertyTaxModal}
      handleEditPropertyTaxModal={handleEditPropertyTaxModal}
      PropertyTaxDetails={PropertyTaxDetails}
      fetchPropertyTaxDetails={fetchPropertyTaxDetails}
    />
  );
  const renderEditInsuranceTaxesModal = () => (
    <InsuranceTaxes
      InsuranceTaxModal={InsuranceTaxModal}
      handleEditInsuranceTaxModal={handleEditInsuranceTaxModal}
      InsuranceTaxDetails={InsuranceTaxDetails}
      fetchInsTaxDetails={fetchInsTaxDetails}
      
    />
  );
  const renderEditHomeWarrantyModal = () => (
    <HomeWarranty
      HomeWarrantyModal={HomeWarrantyModal}
      handleEditHomeWarrantyModal={handleEditHomeWarrantyModal}
      HomeWarrantyDetails={HomeWarrantyDetails}
      fetchHomeWarrantyDetails={fetchHomeWarrantyDetails}
    />
  );
  const renderEditMortgageModal = () => (
    <MortgageSchedule
      MortgageModal={MortgageModal}
      handleEditMortgagePaymentModal={handleEditMortgagePaymentModal}
      values={values}
      fetchLoanDetails={fetchLoanDetails}
      firstPrincipal={firstPrincipal}
      secondPrincipalAmt={secondPrincipalAmt}
    />
  );
  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);

    if (!validateInput()) {
      //   showError("Please fill in all required fields correctly.");

      return false;
    }
    const details = await editPropertyDetails(values, values.id);
    if (details?.data) {
      showSuccess("Record updated successfully");
      // insert settings value
      setIsLoading(false);
     /* setTimeout(() => {
        navigate("/home-purchase/portfolio/realestate");
      }, 1000);*/
      setData({ purchasePrice: details?.purchasePrice, addressOne: details?.addressOne,appreciation:details?.appreciation,dataPresent: true});
    } else {
      showError(details?.message);
    }
  };

  return (
    <div>
      <div className="grid mr-5">
        <div className="col-4"></div>
        <div className="col-6 mt-2">
          <span style={{ color: "#6c757d", fontSize: "1.2rem" }}>
            <b>{values?.addressOne}</b>
          </span>
        </div>
      </div>
      <Panel className={`mb-2 OwnHouse `}>
        {isLoading && <Loading />}
        <Toast ref={toast} className="ToastMessage" />
        <div className={`mb-2 align-text`}>
          <div>
            <div className="grid mr-6">
              <div className="col-12 md:col-12 lg:col-4 mt-3">
                <label>Purchase Price</label>
              </div>
              <div className="col-12 md:col-12 lg:col-6">
                <div className="field">
                  <div className="p-inputgroup">
                    <InputNumber
                      autoComplete="off"
                      required={true}
                      useGrouping={true}
                      name="purchasePrice"
                      disabled={true}
                      prefix="$ "
                      value={values?.purchasePrice}
                    />
                  </div>
                </div>

                <div className="text-align-left">
                  {formSubmitted && !values?.purchasePrice && (
                    <small className="p-error">
                      Please enter purchase price
                    </small>
                  )}
                </div>
              </div>
            </div>

            <div className="grid mr-6">
              <div className="col-12 md:col-12 lg:col-4 mt-3">
                <label>Downpayment</label>
              </div>
              <div className="col-12 md:col-12 lg:col-6">
                <div className="field">
                  <div className="p-inputgroup">
                    <NumericFormat
                      className="input-field"
                      style={{ width: "100%" }}
                      autoComplete="off"
                      required={true}
                      name="downPayment"
                      thousandSeparator=","
                      prefix="$ "
                      value={values?.downPayment}
                      onBlur={(rent) => {
                        handleInputChangeRent("downPayment", rent);
                      }}
                      allowNegative={false}
                    />
                  </div>
                </div>

                <div className="text-align-left">
                  {formSubmitted && !values?.downPayment && (
                    <small className="p-error">Please enter down payment</small>
                  )}
                </div>
              </div>
            </div>

            <div className="grid mr-6">
              <div className="col-12 md:col-12 lg:col-4 mt-3">
                <label>First Loan Principal</label>
              </div>
              <div className="col-12 md:col-12 lg:col-6">
                <div className="field">
                  <div className="p-inputgroup">
                    <InputNumber
                      className="vw-inputnumber-with-border"
                      autoComplete="off"
                      required={true}
                      autoFocus
                      prefix="$ "
                      disabled={true}
                      name="mortgage"
                      onValueChange={handleInputChange}
                      value={values?.mortgage}
                    />
                  </div>
                </div>

                {formSubmitted && !values?.mortgage && (
                  <div className="text-align-left errormsg-margin">
                    <small className="p-error">Please enter mortgage</small>
                  </div>
                )}
              </div>

            </div>
            <div className="grid mr-6">
              <div className="col-12 md:col-12 lg:col-4 mt-3">
                <label>First Loan Amortization</label>
              </div>
              <div className="col-12 md:col-12 lg:col-6">
                <div className="field">
                  <div className="p-inputgroup">
                    <InputNumber
                      className="vw-inputnumber-with-border"
                      autoComplete="off"
                      required={true}
                      autoFocus
                      suffix=" years"
                      disabled={true}
                      name="mortgage"
                      value={values?.amortization}
                    />
                  </div>
                </div>
              </div>

            </div>
            <div className="grid mr-6">
              <div className="col-12 md:col-12 lg:col-4 mt-3">
                <label>First Loan Interest Rate</label>
              </div>
              <div className="col-12 md:col-12 lg:col-6">
                <div className="field">
                  <div className="p-inputgroup">
                    <InputNumber
                      className="vw-inputnumber-with-border"
                      autoComplete="off"
                      required={true}
                      suffix=" %"
                      disabled={true}
                      min={1.0}
                      max={99.999}
                      minFractionDigits={3}
                      maxFractionDigits={3}
                      name="rateOfInterest"
                      value={values?.rateOfInterest}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="grid mr-6">
              <div className="col-12 md:col-12 lg:col-4 mt-3">
                <label>Second Loan Principal</label>
              </div>
              <div className="col-12 md:col-12 lg:col-6">
                <div className="field">
                  <div className="p-inputgroup">
                    <InputNumber
                      className="vw-inputnumber-with-border"
                      autoComplete="off"
                      required={true}
                      autoFocus
                      disabled={true}
                      prefix="$ "
                      name="secondPrincipal"
                      value={values?.secondPrincipal}
                    />
                  </div>
                </div>
              </div>

            </div>
            <div className="grid mr-6">
              <div className="col-12 md:col-12 lg:col-4 mt-3">
                <label>Second Loan Amortization</label>
              </div>
              <div className="col-12 md:col-12 lg:col-6">
                <div className="field">
                  <div className="p-inputgroup">
                    <InputNumber
                      className="vw-inputnumber-with-border"
                      autoComplete="off"
                      required={true}
                      autoFocus
                      suffix=" years"
                      disabled={true}
                      name="mortgage"
                      value={values?.secondAmortization}
                    />
                  </div>
                </div>
              </div>

            </div>
            <div className="grid mr-6">
              <div className="col-12 md:col-12 lg:col-4 mt-3">
                <label>Second Loan Interest Rate</label>
              </div>
              <div className="col-12 md:col-12 lg:col-6">
                <div className="field">
                  <div className="p-inputgroup">
                    <InputNumber
                      className="vw-inputnumber-with-border"
                      autoComplete="off"
                      required={true}
                      suffix=" %"
                      minFractionDigits={1}
                      disabled={true}
                      name="secondRateOfInterest"
                      value={values?.secondRateOfInterest}
                    />
                  </div>
                </div>

                {formSubmitted && !values?.rateOfInterest && (
                  <div className="text-align-left errormsg-margin">
                    <small className="p-error">Please enter rate</small>
                  </div>
                )}
              </div>
            </div>

            <div className="grid mr-6">
              <div className="col-12 md:col-12 lg:col-4 mt-3">
                <label>Monthly Mortgage Payment</label>
              </div>
              <div className="col-12 md:col-12 lg:col-6">
                <div className="field">
                  <div className="p-inputgroup">
                    <InputNumber
                      className="vw-inputnumber-with-border"
                      autoComplete="off"
                      required={true}
                      disabled={true}
                      prefix="$ "
                      name="mortgagePayments"
                      value={loan?loan.monthlyPay:Math.abs(values?.mortgagePayments)}
                    />
                  </div>
                </div>

                {formSubmitted && !values?.mortgagePayments && (
                  <div className="text-align-left errormsg-margin">
                    <small className="p-error">Please enter mortgage payment</small>
                  </div>
                )}
              </div>
              <div className="col-1 pt-4">
                <a href="javascript:;" className=""  onClick={handleEditMortgagePaymentModal}>
                  <i className={`pi pi-pencil`} />
                </a>
              </div>
            </div>

            <div className="grid mr-6">
            <div className="col-12 md:col-12 lg:col-4 mt-3">
                <label>Mortgage Payment Due Date</label>
              </div>
              <div className={`${isDesktopOrLaptop ? "" : "col-11"}`}>
              <div style={{ display: "flex" }}>
            <div className="col-12">
                <Dropdown
                  className=" vw-dropdown  vw-dropdown-with-border"
                  value={selectedMonth}
                  options={months}
                  onChange={handleMonthChange}
                  placeholder="Month"
                  style={{
                    width: "100px",
                    border: "1px solid #ced4da", // Customize the border color and width
                    borderRadius: "3px", // Optional: round the corners
                    padding: "5px", // Optional: add padding for spacing
                    height: "3.5rem",
                  }}
                />
              </div>
              <div className="col-12" >
                <Dropdown
                  className=" vw-dropdown  vw-dropdown-with-border"
                  value={selectedDay}
                  placeholder="Day"
                  options={days}
                  onChange={handleDayChange}
                  emptyMessage="Plese select Month"
                  style={{
                    width: "10px",
                    border: "1px solid #ced4da", // Customize the border color and width
                    borderRadius: "3px", // Optional: round the corners
                    padding: "5px", // Optional: add padding for spacing
                    height: "3.5rem",
                  }}
                />
              </div>
              </div>
              {formSubmitted && !selectedDay && (
              <small className="p-error mr-7"><label className="p-error errorMargin">Please enter date</label></small>
            )}
            </div>
           
          </div>

            <div className="grid mr-6">
              <div className="col-12 md:col-12 lg:col-4 mt-3">
                <label>Rate Type</label>
              </div>
              <div className="col-12 md:col-12 lg:col-6">
                <div className="field">
                  <div className="p-inputgroup">
                    <Dropdown
                      className="vw-dropdown zipcode-dropdown"
                      value={values?.rateOfInterestType}
                      options={options}
                      required={true}
                      name="rateOfInterestType"
                      onChange={handleInputChange}
                      optionLabel="name"
                      optionValue="name"
                      style={{
                        border: "1px solid #ced4da", // Customize the border color and width
                        borderRadius: "3px", // Optional: round the corners
                        padding: "5px", // Optional: add padding for spacing
                      }}
                    />
                  </div>
                </div>

                {formSubmitted && !values?.rateOfInterestType && (
                  <div className="text-align-left errormsg-margin">
                    <small className="p-error">Please enter rate type</small>
                  </div>
                )}
              </div>
            </div>

            <div className="grid mr-6">
              <div className="col-12 md:col-12 lg:col-4 mt-3">
                <label>First Reset</label>
              </div>
              <div className="col-12 md:col-12 lg:col-6">
                <div className="field">
                  <div className="p-inputgroup">
                    <NumericFormat
                      className="input-field"
                      style={{"width":"100%"}}
                      thousandSeparator=","
                      autoComplete="off"
                      required={true}
                      suffix=" %"
                      isAllowed={(val) => {
                        const { floatValue } = val;
                        return floatValue === undefined || (floatValue >= minValue && floatValue <= maxValue);
                      }}
                      decimalScale={2}
                      name="firstReset"
                      onBlur={(firstReset) => {
                        handleInputChanges("firstReset", firstReset);
                        }}
                      value={values?.firstReset}
                    />
                  </div>
                </div>

                {formSubmitted && !values?.city && (
                  <div className="text-align-left errormsg-margin">
                    <small className="p-error">Please enter first reset</small>
                  </div>
                )}
              </div>
            </div>

            <div className="grid mr-6">
              <div className="col-12 md:col-12 lg:col-4 mt-3">
                <label>Rate Cap</label>
              </div>
              <div className="col-12 md:col-12 lg:col-6">
                <div className="field">
                  <div className="p-inputgroup">
                    <NumericFormat
                      className="input-field"
                      style={{"width":"100%"}}
                      thousandSeparator=","
                      autoComplete="off"
                      required={true}
                      suffix=" %"
                      isAllowed={(val) => {
                        const { floatValue } = val;
                        return floatValue === undefined || (floatValue >= minValue && floatValue <= maxValue);
                      }}
                      decimalScale={2}
                      name="rateCap"
                      onBlur={(rateCap) => {
                      handleInputChanges("rateCap", rateCap);
                      }}
                      value={values?.rateCap}
                    />
                  </div>
                </div>

                {formSubmitted && !values?.city && (
                  <div className="text-align-left errormsg-margin">
                    <small className="p-error">Please enter rate cap</small>
                  </div>
                )}
              </div>
            </div>

            <div className="grid mr-6">
              <div className="col-12 md:col-12 lg:col-4 mt-3">
                <label>Max Rate</label>
              </div>
              <div className="col-12 md:col-12 lg:col-6">
                <div className="field">
                  <div className="p-inputgroup">
                    <NumericFormat
                      className="input-field"
                      style={{"width":"100%"}}
                      thousandSeparator=","
                      autoComplete="off"
                      required={true}
                      name="maxRate"
                      suffix=" %"
                      isAllowed={(val) => {
                        const { floatValue } = val;
                        return floatValue === undefined || (floatValue >= minValue && floatValue <= maxValue);
                      }}
                      decimalScale={2}
                      onBlur={(maxRate) => {
                      handleInputChanges("maxRate", maxRate);
                      }}
                      value={values?.maxRate}
                    />
                  </div>
                </div>

                {formSubmitted && !values?.city && (
                  <div className="text-align-left errormsg-margin">
                    <small className="p-error">Please enter max rate</small>
                  </div>
                )}
              </div>
            </div>

          

            <div className="grid mr-6">
              <div className="col-12 md:col-12 lg:col-4 mt-3">
                <label>HOA</label>
              </div>
              <div className="col-12 md:col-12 lg:col-6">
                <div className="field">
                  <div className="p-inputgroup">
                    <InputNumber
                      className="vw-inputnumber-with-border"
                      autoComplete="off"
                      required={true}
                      name="hoa"
                      disabled={true}
                      prefix="$ "
                       minFractionDigits={0}
                      maxFractionDigits={0}
                      onValueChange={handleInputChange}
                      value={totalHOA !== 0? totalHOA : values?.hoa}
                    />
                  </div>
                </div>
              </div>
              <div className="ml-2 pt-4">
                <a
                  href="javascript:;"
                  className=""
                  onClick={handleEditHOAModal}
                >
                  <i className={`pi pi-pencil`} />
                </a>
              </div>
              <div className="ml-2 pt-4">
                <span onClick={handleEditHOAModal} style={{ cursor: "pointer" }}>Set Alert</span>
              </div>
            </div>

            <div className="grid mr-6">
              <div className="col-12 md:col-12 lg:col-4 mt-3">
                <label> Property Taxes</label>
              </div>
              <div className="col-12 md:col-12 lg:col-6">
                <div className="field">
                  <div className="p-inputgroup">
                    <InputNumber
                      className="vw-inputnumber-with-border"
                      autoComplete="off"
                      required={true}
                      name="propertyTaxes"
                      disabled={true}
                      prefix="$ "
                      minFractionDigits={0}
                      maxFractionDigits={0}
                      onValueChange={handleInputChange}
                      value={totalPTax !== 0? totalPTax : values?.propertyTaxes}
                    />
                  </div>
                </div>
              </div>
              <div className="ml-2 pt-4">
                <a
                  href="javascript:;"
                  className=""
                  onClick={handleEditPropertyTaxModal}
                >
                  <i className={`pi pi-pencil`} />
                </a>
              </div>
              <div className="ml-2 pt-4">
                <span onClick={handleEditPropertyTaxModal} style={{ cursor: "pointer" }}>Set Alert</span>
              </div>
            </div>

            <div className="grid mr-6">
              <div className="col-12 md:col-12 lg:col-4 mt-3">
                <label> Insurance</label>
              </div>
              <div className="col-12 md:col-12 lg:col-6">
                <div className="field">
                  <div className="p-inputgroup">
                    <InputNumber
                      className="vw-inputnumber-with-border w-100"
                      autoComplete="off"
                      required={true}
                      disabled={true}
                      prefix="$ "
                       minFractionDigits={0}
                      maxFractionDigits={0}
                      name="insurance"
                      onValueChange={handleInputChange}
                      value={totalInsurance !== 0? totalInsurance : values?.insurance}
                    />
                  </div>
                </div>
              </div>
              <div className="ml-2 pt-4">
                <a
                  href="javascript:;"
                  className=""
                  onClick={handleEditInsuranceTaxModal}
                >
                  <i className={`pi pi-pencil`} />
                </a>
              </div>
              <div className="ml-2 pt-4">
                <span onClick={handleEditInsuranceTaxModal} style={{ cursor: "pointer" }}>Set Alert</span>
              </div>
            </div>

            <div className="grid mr-6">
              <div className="col-12 md:col-12 lg:col-4 mt-3">
                <label> Home Warranty</label>
              </div>
              <div className="col-12 md:col-12 lg:col-6">
                <div className="field">
                  <div className="p-inputgroup">
                    <InputNumber
                      className="vw-inputnumber-with-border w-100"
                      autoComplete="off"
                      required={true}
                      prefix="$ "
                      disabled={true}
                       minFractionDigits={0}
                      maxFractionDigits={0}
                      name="homeWarranty"
                      onValueChange={handleInputChange}
                      value={totalHomeWarranty !== 0? totalHomeWarranty : values?.homeWarranty}
                    />
                  </div>
                </div>
              </div>
              <div className="ml-2 pt-4">
                <a
                  href="javascript:;"
                  className=""
                  onClick={handleEditHomeWarrantyModal}
                >
                  <i className={`pi pi-pencil`} />
                </a>
              </div>
              <div className="ml-2 pt-4">
                <span onClick={handleEditHomeWarrantyModal} style={{ cursor: "pointer" }}>Set Alert</span>
              </div>
            </div>

            {renderFooter()}
          </div>
        </div>
      </Panel>
      {HOAModal && renderEditHOAModal()}

      {PropertyTaxModal && renderEditPropertyTaxesModal()}

      {InsuranceTaxModal && renderEditInsuranceTaxesModal()}
      {HomeWarrantyModal && renderEditHomeWarrantyModal()}
      {MortgageModal && renderEditMortgageModal()}
    </div>
  );
};

export default PropertyPayments;
